import { render } from "./SeDeleteConfirmModal.vue?vue&type=template&id=2a5e0fa2&ts=true"
import script from "./SeDeleteConfirmModal.vue?vue&type=script&lang=ts"
export * from "./SeDeleteConfirmModal.vue?vue&type=script&lang=ts"

import "./SeDeleteConfirmModal.vue?vue&type=style&index=0&id=2a5e0fa2&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__